<template>
  <div class="clickable action" @click="$emit('click')">
    <h-icon>{{icon}}</h-icon>
    <div class="test">{{name}}</div>
  </div>
</template>

<script>
export default {
  props: ["icon", "name"]
}
</script>

<style lang="less" scoped>
.action {
  font-size: 12px;
  height: 15px + 24px + 20px;
  opacity: 0.7;

  &:hover {
    font-size: 14px !important;
    opacity: 1;
    .material-icons {
      font-size: 28px;
    }
  }
}
</style>

